import Vue from 'vue'
import VueRouter from 'vue-router'
import LegacyPage from '@/views/index.vue'
import HomePage from '@/views/HomePage.vue'
import ListPage from '@/views/ListPage.vue'
import DetailPage from '@/views/DetailPage.vue'
import MinePage from '@/views/MinePage.vue'
import CityPage from '@/views/CityPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { title: '首页' }
  },
  {
    path: '/city',
    name: 'city',
    component: CityPage,
    meta: { title: '同城' }
  },
  {
    path: '/list',
    name: 'list',
    component: ListPage,
    meta: { title: '分类列表' }
  },
  {
    path: '/detail',
    name: 'detail',
    component: DetailPage,
    meta: { title: '视频详情' }
  },
  {
    path: '/mine',
    name: 'mine',
    component: MinePage,
    meta: { title: '我的' }
  },
  {
    path: '/legacy',
    name: 'legacy',
    component: LegacyPage,
    meta: { title: '旧版业务页' }
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})




export default router
